module.exports = __webpack_public_path__ + "img/free-products.e3dc6bba.svg";